import React, { Component } from 'react';
import { connect } from 'react-redux';

import { deleteNote, openNoteEditor } from 'PipeRouter';

import EditNoteOptionsViews from './views';


class EditNoteOptions extends Component {
  removeNote = () => {
    const { deleteNote, selectedHighlight } = this.props;

    deleteNote(selectedHighlight);
  }

  render() {
    const viewProps = {
      openNoteEditor: this.props.openNoteEditor,
      removeNote: this.removeNote
    };

    return <EditNoteOptionsViews { ...viewProps } />;
  }
}


function mapStateToProps(state) {
  return {
    selectedHighlight: state.selectedHighlight
  };
}

export default connect(mapStateToProps, {
  deleteNote,
  openNoteEditor
})(EditNoteOptions);
